import shouldRedirectForQueryChange from "./shouldRedirectForQueryChange";

export type SearchSubmitIntent = "query" | "facets";

/*
 * Full-page query redirect is only for keyword Enter submits.
 * Apply filters must stay in-app so facet selections are not dropped.
 */
const shouldUseQueryRedirect = (
    submitIntent: SearchSubmitIntent,
    fullUrl: string,
    newQuery: string
): string | null => {
    if (submitIntent !== "query") {
        return null;
    }

    return shouldRedirectForQueryChange(fullUrl, newQuery);
};

export default shouldUseQueryRedirect;
